(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiseaseTypeDialogController', DiseaseTypeDialogController);

    DiseaseTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DiseaseType'];

    function DiseaseTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DiseaseType) {
        var vm = this;
        vm.diseaseType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:diseaseTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.diseaseType.id !== null) {
                DiseaseType.update(vm.diseaseType, onSaveSuccess, onSaveError);
            } else {
                DiseaseType.save(vm.diseaseType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
